<template>
    <div>
     <!-- 面包屑导航 -->
     <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>年费查询（在年费库且超过更新时间30天）</el-breadcrumb-item>
     </el-breadcrumb>
     <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" @click="refresh" title="点击刷新页面">刷新</el-button>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search" title="点击跳转国知局查询专利年费">年费查询</el-button>
        <el-button size="small" type="warning">账号1:17628291613</el-button>
        <el-button size="small" type="warning">密码1:Ty@12345678</el-button>
        <el-button size="small" type="warning">账号2:18227357021</el-button>
        <el-button size="small" type="warning">密码2:lichen941005@JAVA</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" >
      <el-table-column align="center" type="index" label="序号" width="60">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column align="center" prop="zlmc" label="专利名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="zlid" label="专利号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="zlid_code" label="专利号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="zlwyid" label="公开号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="zllx" label="专利类型" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="apply_date" label="申请日" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="upd_date" label="更新日" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
          <el-button size="mini" type="warning" @click="updPatDate(scope.$index, scope.row)" title="年费数据一致,直接更新时间">更新</el-button>
          <el-button size="mini" type="warning" @click="handleInput(scope.$index, scope.row)" title="年费录入">录入</el-button>
          <el-button size="mini" type="danger" @click="delMonitor(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 监控详情界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('infoForm')">
      <el-form label-width="120px" :model="infoForm" ref="infoForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="专利名称">
              <el-input size="small" v-model="infoForm.zlmc" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="专利号">
              <el-input size="small" v-model="infoForm.zlid" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="专利类型">
              <el-input size="small" v-model="infoForm.zllx" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专利号">
              <el-input size="small" v-model="infoForm.zlid_code" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="公开号">
              <el-input size="small" v-model="infoForm.zlwyid" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请日">
              <el-input size="small" v-model="infoForm.apply_date" auto-complete="off" disabled></el-input>
            </el-form-item>           
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 年费录入界面 -->
    <el-dialog :title="title" :visible.sync="feeFormVisible" width="50%" @click="closeDialog('feeForm')">
    <el-form :model="annualFeeForm" ref="annualFeeForm" label-width="100px" class="demo-dynamic">
            
        <el-row>
          <el-col :span="12">
            <el-form-item label="专利名称">
              <el-input size="small" v-model="feeForm.zlmc" auto-complete="off" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专利号">
              <el-input size="small" v-model="feeForm.zlid_code" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      <el-form-item label="待缴年费">
        <el-row class="demo-autocomplete">
              <el-col :span="6">
                <div class="sub-title" style="color: #909399">费用种类</div>
              </el-col>
              <el-col :span="6">
                <div class="sub-title" style="color: #909399">应缴金额</div>
              </el-col>
              <el-col :span="6">
              <div class="sub-title" style="color: #909399">缴费截止日</div>
            </el-col>
          </el-row>
      </el-form-item>

       <el-form-item
        v-for="(domain, index) in annualFeeForm.pay_able"
        :label="'费用' + index"
        :key="domain.key"
      >
      <el-row class="demo-autocomplete">
            <el-col :span="6">
              <el-input :prop="domain.category" v-model="domain.category" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:发明专利第6年年费"></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 15px">
            <el-input :prop="domain.money" v-model="domain.money" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:1200"></el-input>
            </el-col>
            <el-col :span="4" style="margin-left: 15px">
              <el-input :prop="domain.date" v-model="domain.date" :rules="{ required: true, message: '不能为空值', trigger: 'blur' }" placeholder="例:2021-05-06"></el-input>
            </el-col>
            <el-button @click.prevent="removeDomain(domain)" style="margin-left: 15px">删除</el-button>
            <el-button @click.prevent="addOnNodeDomain(domain)" title="当前节点上方添加录入框">添加(上)</el-button>
            <el-button @click.prevent="addNextNodeDomain(domain)" title="当前节点下方添加录入框">添加(下)</el-button>
      </el-row>
        <!-- <el-input v-model="domain.value"></el-input> -->
        
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('annualFeeForm')">提交</el-button>
        <el-button @click="addDomain">新增录入行</el-button>
        <!-- <el-button @click="resetForm('annualFeeForm')">重置</el-button> -->
      </el-form-item>
    </el-form>

    </el-dialog>

    </div>
</template>

<script>
import { webPatFeeQuery, webPatFeeUpdDate, webPatUpdOneFee } from '../../api/webMG'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      feeFormVisible: false, //控制年费录入页面显示与隐藏
      title: '监控详情',
      infoForm: {
        zllx: '',
        zlmc: '',
        zlid: '',
        zlid_code: '',
        apply_date: ''
      },
      feeForm: {
        zlid: '',
        zlmc: ''
      },
      listData: [], //用户数据
      feeData: [], // 年费数据
      annualFeeForm: {
          zlid: '',
          pay_able: [{
            category: '',
            money: '',
            date: ''
          }],
        }
    }
  },
  // 注册组件
  components: {
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata() {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      webPatFeeQuery()
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 刷新页面
    refresh() {
        this.getdata()
    },
    // 搜索事件
    search() {
      window.open("http://cpquery.cnipa.gov.cn/", "_blank");
    },
    //显示详情界面
    handleInfo: function(index, row) {
      // console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
    //显示年费录入界面
    handleInput: function(index,row){
        this.title = '年费录入'
        this.feeFormVisible = true
        this.feeForm = row
        this.annualFeeForm.zlid = row.zlid
        this.annualFeeForm.pay_able = row.pay_able
    },
    //更新年费时间
    updPatDate: function(index,row){
      const updParam = {
            zlid:row.zlid
        }
    this.$confirm('确定更新?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          webPatFeeUpdDate(updParam)
            .then(res => {
              console.log(res)
              res = checkLogin(res)
              if (res.code == 200) {
                this.loading = false
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              location.reload()
              
              } else {
                this.loading = false
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
        })
        .catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消更新'
          })
        })
    },  
    // 删除监控记录
    delMonitor(index, row) {
        this.$message({
          type: 'info',
          message: '暂不支持!'
        })
        return false;
    },
    // 提醒勾选中的记录
    remindCheck(index, row) {
        this.$message({
          type: 'info',
          message: '暂不支持!'
        })
        return false;
    },

    submitForm(formName) {
    this.$refs[formName].validate((valid) => {
      console.log(valid)
      if (valid) {
      const param = { zlid:this.annualFeeForm.zlid,pay_able:JSON.stringify(this.annualFeeForm.pay_able) }
      webPatUpdOneFee(param)
        .then(res => {
          this.loading = false
          res = checkLogin(res)
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: res.msg
            })
            location.reload()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
      } else {
        console.log('error submit!!');
        return false;
      }
    });
  },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    removeDomain(item) {
      var index = this.annualFeeForm.pay_able.indexOf(item)
      if (index !== -1) {
        this.annualFeeForm.pay_able.splice(index, 1)
      }
    },
    // 当前节点添加输入行
    addOnNodeDomain(item) {
      var index = this.annualFeeForm.pay_able.indexOf(item)
      this.annualFeeForm.pay_able.splice(index, 0,{key: Date.now()})
    },
    addNextNodeDomain(item) {
      var index = this.annualFeeForm.pay_able.indexOf(item)
      this.annualFeeForm.pay_able.splice(index+1, 0,{key: Date.now()})
    },
    addDomain() {
      this.annualFeeForm.pay_able.push({
        key: Date.now()
      });
    }
    
  }
}
</script>


// WEBPACK FOOTER //
// src/views/patent/Queryfee.vue